<template>
  <div class="form-item">
    <textarea
      :id="field"
      :name="field"
      :maxlength="maxLenght"
      :rows="rows"
      :placeholder="labelText"
      :value="fieldValue"
      @change="handleInput($event)"
    ></textarea>
    <label :for="field"> {{ labelText }} </label>
    <p v-show="!isValid" class="rgErrorMessage">{{ errorText }}</p>
  </div>
</template>
<script>
export default {
  name: "TextArea",
  props: {
    field: { type: String, default: "msg" },
    labelText: { type: String },
    errorText: { type: String },
    isValid: { type: Boolean, default: true },
    maxLenght: { type: Number, default: 3500 },
    rows: { type: Number, default: 4 },
    curValue: { type: String },
  },
  computed: {
    fieldValue: {
      get() {
        return this.curValue;
      },
      set(val) {
        this.$emit("update:curValue", val);
      },
    },
  },
  methods: {
    handleInput(e) {
      this.fieldValue = e.target.value;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./Input.scss";
</style>
